export default "__VITE_ASSET__9Z82Lzwu__"